module.exports = __webpack_public_path__ + "img/upgrade_center_icon1.790fef4c.png";